import React from 'react'
import "./About.scss";

import { motion } from 'framer-motion';
import { bios } from '../../../Data';
import portfolio from "../../../assets/portfolio.jpg"
import resume from '../../../assets/Resume-Vihaan_Shah.pdf'

const About = () => {


  return (
    <div className="container " id='about'>
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ y: [-50, 0], opacity: 1 }}
        className="title">
        <span style={{color: "#d2e8f5"}}>Who Am I?</span>
        <h1>About Me</h1>
      </motion.div>

      <div className="about_container">
        <motion.div
          initial={{ x: 0, opacity: 0 }}
          whileInView={{ x: [-250, 0], opacity: 1 }}
          transition={{ duration: 1 }}
          className="about_left">
          <motion.img src={portfolio}
            whileHover={{ y: -48, x: -55 }}
            transition={{ duration: 0.3 }}
          />
        </motion.div>
        <motion.div className="about_right"
          initial={{ x: 0, opacity: 0 }}
          whileInView={{ x: [250, 0], opacity: 1 }}
          transition={{ duration: 1 }}
        >

          <p>I am a highly motivated and experienced Software Engineer with a passion for problem solving and creating innovative solutions. I have a proven track record of successfully developing, testing, and deploying software applications. My expertise lies in developing web applications using Java, JavaScript, HTML, CSS, and various frameworks such as Angular and React. I am also experienced in developing mobile applications with Android and iOS. I am a fast learner who is eager to learn new technologies and stay up-to-date with industry trends. I am confident that I can help your team to create successful software applications and exceed your expectations.</p>
          {bios.map(bio => {
            return (
              <div className="bio" key={bio.id}>
                <span className='bioKey'>{bio.icon}{bio.key}</span>
                <span className='bioValue'>{bio.value}</span>
              </div>
            )
          })}
          <motion.a href={resume} download=''
            whileHover={{ scale: 1.1, color: "#d2e8f5" }}
            transition={{ duration: 0.3 }}
          >
            Download Resume
          </motion.a>
        </motion.div>

      </div>

    </div>
  )
}

export default About